import * as React from 'react';

export const LeftArrow: React.FC<{ fill?: string }> = ({ fill = 'white' }) => (
  <svg width="6" height="16" viewBox="0 0 6 16" fill="none">
    <path d="M6 8L0 0V16L6 8Z" fill={fill} />
  </svg>
);
